//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'wash',
  components: {
  },
  data () {
    return {
      count:{
        'xidi':0,
        'time_out':0,
      },
      nav:[
          {
          title:'扎带码录单',
          path:'/bagCodeRecord/1',
          auth:'bagCodeRecord',
          img:'/static/images/status1.png',
        },
          {
          title:'手机号录单',
          path:'/bagCodeRecord/3',
          auth:'phoneRecord',
          img:'/static/images/status5.png',
        },
          {
          title:'衣物上挂',
          path:'/upClothe',
          auth:'upClothe',
          img:'/static/images/store-visit-lined.png',
        },
          {
          title:'顾客取衣',
          path:'/pickClothe',
          auth:'pickClothe',
          img:'/static/images/pickup.png',
        },
          {
          title:'附件补录',
          path:'/annex',
          auth:'annex',
          img:'/static/images/bar.png',
        },
          {
          title:'撤单',
          path:'/cancelRecord',
          auth:'cancelRecord',
          img:'/static/images/submit.png',
        },
           {
          title:'回店记录',
          path:'/backStore',
          auth:'backStore',
          img:'/static/images/store-visit-lined.png',
        },
      ],
      nav1:[
         {
          title:'今日送洗',
          path:'/todayRecordList',
          auth:'todayRecordList',
          img:'/static/images/drivered.png',
        },
            {
          title:'手机号查询',
          path:'/recordPhoneList',
          auth:'recordPhoneList',
          img:'/static/images/pickuped.png',
        },
          {
          title:'洗涤中',
          path:'/clotheWash',
          auth:'clotheWash',
          img:'/static/images/arrivaled.png',
          key:'xidi'
        },
          {
          title:'上挂列表',
          path:'/upList',
          auth:'upList',
          img:'/static/images/upList.png',
        },
          {
          title:'取衣记录',
          path:'/pickList',
          auth:'pickClothe',
          img:'/static/images/pickup.png',
        },
        
          {
          title:'超时衣物',
          path:'/timeOutClotheWash',
          auth:'timeOutClotheWash',
          img:'/static/images/timeout.png',
          key:'time_out'
        },
          {
          title:'衣物图片',
          path:'/clothePhoto',
          auth:'clothePhoto',
          img:'/static/images/photo.png',
        },
          {
          title:'条码查询',
          path:'/barOrder',
          auth:'barOrder',
          img:'/static/images/bar.png',
        },
            {
          title:'综合查询',
          path:'/recordList',
          auth:'recordList',
          img:'/static/images/status6.png',
        },
      ],
    }
  },
  created(){
    this.getClotheCount();
  
  },
  mounted(){

  },
  methods:{
    getClotheCount(){
      this.$api.getClotheCount({}).then((res)=>{
        this.count = res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/recordOrder.vue